import { CUSTOMER_TABS, defineModule } from "@motolynk/app-core";

import { CustomerVehiclesTab } from "./admin/CustomerVehiclesTab";

import en from "./i18n/en.json";

export const vehiclesModule = defineModule({
  name: "vehicles",
  label: "Vehicles",
  requires: ["core", "accounts"],
  i18n: { en },
  admin: {
    routes: [
      {
        path: "vehicles",
        permission: "vehicles.view_vehiclemake",
        page: () => import("./admin/VehiclesPage"),
      },
    ],
    nav: [
      {
        id: "vehicles",
        group: "catalog",
        label: "vehicles:nav",
        icon: "car",
        to: "/vehicles",
        permission: "vehicles.view_vehiclemake",
        order: 5,
      },
    ],
    slots: {
      [CUSTOMER_TABS]: [
        {
          id: "vehicles",
          label: "vehicles:customerTab.label",
          permission: "vehicles.view_customervehicle",
          component: CustomerVehiclesTab,
        },
      ],
    },
  },
});
